import { Check, ArrowRight, BellRing } from "lucide-react";
import { Reveal } from "./Reveal";
import { REGISTRATION_URL } from "./data";

const INCLUDED = ["Live class 4 jam via Zoom", "Q&A langsung dengan praktisi", "Materi eksklusif", "E-Sertifikat"];

export const Pricing = () => (
    <section id="daftar" className="relative scroll-mt-20 overflow-hidden bg-gradient-to-b from-[#071B37] via-[#123E65]/60 to-[#071B37] py-20 lg:py-28" data-testid="pricing-section">
        <div className="gold-hairline absolute left-0 top-0 h-px w-full" />
        <div className="mx-auto max-w-3xl px-5 lg:px-8">
            <Reveal className="text-center">
                <p className="text-xs font-semibold uppercase tracking-[0.22em] text-[#DDB56C]">Investasi Kelas</p>
                <h2 className="mt-4 text-3xl font-extrabold tracking-tight text-white sm:text-4xl" data-testid="pricing-heading">
                    Investasi Ilmu Hari Ini, untuk{" "}
                    <span className="font-accent italic text-gold-gradient">Keputusan Properti yang Lebih Matang.</span>
                </h2>
            </Reveal>
            <Reveal delay={0.15}>
                <div className="relative mt-12 rounded-[2rem] border-2 border-[#DDB56C]/60 bg-[#071B37] p-8 shadow-[0_32px_80px_rgba(221,181,108,0.18)] sm:p-12" data-testid="pricing-card">
                    <span className="absolute -top-4 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-[#DDB56C] px-6 py-2 text-xs font-extrabold uppercase tracking-[0.15em] text-[#071B37] shadow-lg" data-testid="pricing-badge">
                        Early Bird Price
                    </span>
                    <div className="text-center">
                        <p className="text-lg font-medium text-white/45 line-through" data-testid="pricing-normal">Rp229.000</p>
                        <p className="mt-1 font-accent text-6xl font-bold text-gold-gradient sm:text-7xl" data-testid="pricing-promo">Rp169.000</p>
                        <p className="mt-4 inline-flex items-center gap-2 rounded-full border border-[#DDB56C]/30 bg-[#DDB56C]/10 px-4 py-2 text-xs font-medium text-[#DDB56C] sm:text-sm" data-testid="pricing-deadline">
                            <BellRing className="h-4 w-4" strokeWidth={1.5} />
                            Early bird berlaku sampai Minggu, 25 Oktober 2026
                        </p>
                    </div>
                    <ul className="mx-auto mt-8 grid max-w-md gap-3 sm:grid-cols-2">
                        {INCLUDED.map((f) => (
                            <li key={f} className="flex items-center gap-2.5 text-sm text-white/80">
                                <Check className="h-4 w-4 shrink-0 text-[#DDB56C]" strokeWidth={2.5} />
                                {f}
                            </li>
                        ))}
                    </ul>
                    <a href={REGISTRATION_URL} target="_blank" rel="noopener noreferrer" data-testid="pricing-cta"
                        className="group mt-10 flex w-full items-center justify-center gap-2 rounded-full bg-[#DDB56C] px-8 py-5 text-lg font-extrabold text-[#071B37] shadow-[0_12px_40px_rgba(221,181,108,0.45)] transition-all duration-300 hover:-translate-y-1 hover:bg-[#e9cf9a] hover:shadow-[0_16px_48px_rgba(221,181,108,0.6)]">
                        Daftar Kelas — Rp169.000
                        <ArrowRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1" strokeWidth={2.5} />
                    </a>
                    <p className="mt-5 text-center text-xs text-white/50 sm:text-sm" data-testid="pricing-note">
                        Kuota terbatas. Konfirmasi ketersediaan pendaftaran melalui halaman registrasi.
                    </p>
                </div>
            </Reveal>
        </div>
    </section>
);
